var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SIDEBAR"},[_vm._v("\n    This will contain more Project-specific data in the future.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }